import http from 'api/http';
import { scheduleDomain } from 'models';
import { PinStatus } from 'models/Schedule';
import { createUrl, commonErrorHandling } from 'store/utils';

export async function pinJob(
  pinStatus: PinStatus,
  date: string,
  engineerId: string,
  appointmentId: string
): Promise<void> {
  try {
    await http.patch(
      `${createUrl(
        scheduleDomain
      )}/${engineerId}/${date}/assignment/${appointmentId}`,
      { pinStatus }
    );
  } catch (error) {
    commonErrorHandling(error, scheduleDomain.type);
    throw error;
  }
}
